export default {
  name: 'performance',
  data () {
    return {
      label: 'PERFORMANCE EVALUATION',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/performanceevaluation/script.js